module.exports = __webpack_public_path__ + "d94e20c1/img/menu-icon.5f8facae.svg";